import React from "react";
import Header from "./home";

const Default = (props) => {
	return <Header noHero />;
};

export default Default;
